import { render, staticRenderFns } from "./RiskyUsersWithPlaybookModal.vue?vue&type=template&id=5234782f&scoped=true&"
import script from "./RiskyUsersWithPlaybookModal.vue?vue&type=script&lang=ts&"
export * from "./RiskyUsersWithPlaybookModal.vue?vue&type=script&lang=ts&"
import style0 from "./RiskyUsersWithPlaybookModal.vue?vue&type=style&index=0&id=5234782f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5234782f",
  null
  
)

export default component.exports